import React, { useCallback, useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Form } from 'semantic-ui-react'
import CommonValueBuildUpTab from '../../../commonComponents/commonValueBuildUpTab'
import ValuBuildUpProvider from '../../../commonComponents/commonValueBuildUpTab/valuBuildUpProvider'
import { useCurrentShipmentType, useForm } from '../../../hooks'
import { updateLineData } from '../../actions'
import { ActorContext } from '../partiesTab/Actors/actorProvider'

const ValueBuildUpTab = (props) => {
  const { translate } = props
  const { invoices,invoiceHeader } = useSelector((state) => state?.InvoicesReducer)
  const incoTerm = useSelector((state) => state.Shipment?.transportation?.tradeTerms?.incoTerms)

  // for latest changes CORE-13487
  const actorDetailsAndActions = useContext(ActorContext)
  const {buyer, importer, seller, exporter } = useSelector(state => state.Actor)
  const procedure = useSelector(state=>state.Shipment.exitInfo?.procedure)
  const { isDMS, isImportShipment, isDisabled } = useCurrentShipmentType()

  const { saveForm } = useForm('')
const dispatch = useDispatch()
  const updateFunc = useCallback(
    (...args) => {
      dispatch(updateLineData(...args))
    },
    [updateLineData]
  )
  const saveFunc = useCallback(
    (merchandiseId, keys, invoiceId,params) => {
      saveForm({
        invoices: [
          {
            invoiceId: invoiceId,
            lineItems: [{ merchandiseId: merchandiseId, invoiceId: invoiceId, ...params }],
          },
        ],
      })
    },
    [saveForm]
  )
  // For Import Scenerio
    const createDutyFunc = useCallback(
      (...args) => {
      },
      []
    )

    const deleteDutyFunc = useCallback(
      (...args) => {
      },
      []
  )

  return (
    <ValuBuildUpProvider
      invoiceData={invoices}
      updateFunc={updateFunc}
      saveFunc={saveFunc}
      statValueKey='statVal'
      createDutyFunc={createDutyFunc}
      deleteDutyFunc={deleteDutyFunc}
    >
      <div className='valueBuildUp formContentareaC88'>
        <Form.Group className='float-container'>
          <CommonValueBuildUpTab 
            translate={translate} 
            invoices={invoices} 
            incoTerm={incoTerm} 
            invoiceAmount={invoiceHeader?.totalValue}
            isDisabled={isDisabled}
            isNLAPP={true}
            isDMS={isDMS}
            isImportShipment={isImportShipment}
            actorDetailsAndActions={actorDetailsAndActions}
            buyer={ buyer?.id ? buyer : importer }
            seller={ seller?.id ? seller : exporter }
            procedure={procedure}
          />
        </Form.Group>
      </div>
    </ValuBuildUpProvider>
  )
}

export default ValueBuildUpTab
